import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from '../../modals/base-modal/base-modal.component';

export interface ResearcherProgress {
  userId: number;
  firstName: string;
  lastName: string;
  role: string;
  completedCount: number;
  totalCount: number;
}

@Component({
  selector: 'app-screening-progress-card',
  standalone: true,
  imports: [CommonModule, BaseModalComponent],
  templateUrl: './screening-progress-card.component.html',
})
export class ScreeningProgressCardComponent {
  @Input() totalPapers = 0;
  @Input() unscreenedPapers = 0;
  @Input() partiallyScreenedPapers = 0;
  @Input() includedPapers = 0;
  @Input() excludedPapers = 0;
  @Input() isPI = false;
  @Input() researcherProgress: ResearcherProgress[] = [];
  @Input() teamTotalDecisions = 0;
  @Input() teamTotalRequiredDecisions = 0;

  readonly showTeamModal = signal(false);

  get progressPercentage(): number {
    if (this.totalPapers === 0) return 0;
    return ((this.totalPapers - this.unscreenedPapers) / this.totalPapers) * 100;
  }

  get screenedCount(): number {
    return this.totalPapers - this.unscreenedPapers;
  }
}
